import { IRequestState, RequestType, IRequestAction } from '../types'

export const initialRequestState = {
  results: [],
  loading: false,
} as IRequestState

export const requestReducer = (state: IRequestState, action: IRequestAction) => {
  switch (action.type) {
    case RequestType.success:
      return { results: action.payload, loading: false }
    case RequestType.request:
      return { results: [], loading: true }
    default:
      return { ...state }
  }
}
